import React from 'react';
import classnames from 'classnames';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { CSWFieldId, getOrderDetailsFieldId } from '../../../../../constants/field-ids';
import LabeledField from '../labeled-field';
import RateBrowserButton from '../../../../../fulfillment-planner/rate-browser-button';
import sharedFieldStyle from '../../../shared-field-labels/form-fields.module.less';
import ShipFromComponent from '../../../../../fulfillment-planner/ship-from';
import { ShipFromLabel, ReturnToLabel } from '../../../shared-field-labels/shared-field-labels';
import ShipFromValidator from '../../../../../fulfillment-planner/ship-from/validator';
import { useEnableMultiPackageShipmentsOrderDetails } from '../../../../../feature-flags/hooks/use-multi-package-shipping-order-details';

import style from './ship-from.module.less';

const fieldId = getOrderDetailsFieldId(CSWFieldId.ShipFrom);

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @param {boolean?} [props.shouldHideRateBrowser]
 * @param {boolean?} [props.isReturn]
 * @param {string?} [props.containerClassName]
 * @returns {JSX.Element}
 */
const ShipFrom = ({ containerClassName = '', fulfillmentPlanId, isReturn = false, shouldHideRateBrowser = false }) => {
  const label = isReturn ? ReturnToLabel : ShipFromLabel;
  const hideRateBrowser = isReturn || shouldHideRateBrowser;
  const enableMultiPackageShipmentsOrderDetails = useEnableMultiPackageShipmentsOrderDetails();
  const showFulfillmentProviders = !isReturn;

  // TODO: use this version when the feature flag is removed
  if (enableMultiPackageShipmentsOrderDetails) {
    return (
      <ShipFromValidator fulfillmentPlanId={fulfillmentPlanId} showFulfillmentProviders={showFulfillmentProviders}>
        {({ validation }) => (
          <LabeledField hasValidationError={validation.helperTextType === INLINE_MESSAGE_TYPES.error} label={label} labelFor={fieldId}>
            <div className={classnames(style['ship-from-container'], containerClassName)}>
              <ShipFromComponent
                dropdownMenuType={DropdownMenuType.ComboBox}
                id={fieldId}
                showFulfillmentProviders={showFulfillmentProviders}
                singleItemTitleClassName={sharedFieldStyle['readonly-value']}
                validation={validation}
              />
            </div>
          </LabeledField>
        )}
      </ShipFromValidator>
    );
  }

  return (
    <ShipFromValidator fulfillmentPlanId={fulfillmentPlanId} showFulfillmentProviders={showFulfillmentProviders}>
      {({ validation }) => (
        <LabeledField
          button={
            !hideRateBrowser && (
              // TODO: Use new calculator icon
              <RateBrowserButton iconClassName={style['rate-browser-icon']} isOnOrderDetails />
            )
          }
          hasValidationError={validation.helperTextType === INLINE_MESSAGE_TYPES.error}
          label={label}
          labelFor={fieldId}
        >
          <div className={classnames(style['ship-from-container'], containerClassName)}>
            <ShipFromComponent
              dropdownMenuType={DropdownMenuType.ComboBox}
              id={fieldId}
              showFulfillmentProviders={showFulfillmentProviders}
              singleItemTitleClassName={sharedFieldStyle['readonly-value']}
              validation={validation}
            />
          </div>
        </LabeledField>
      )}
    </ShipFromValidator>
  );
};

export default ShipFrom;
